import React, { useCallback } from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Modal from '../../modals/Modal';
import Button from '../../shared/Button';

import './case-approve-date-modal.scss';

const CaseApproveDateModal = (props) => {
  const { open, onClose, selectedCase, onApprove, onReject, loading, hospitals = [] } = props;
  const requestedDate = selectedCase?.requestedSurgeryDate?.newDate || selectedCase?.requestedSurgeryDateNew;
  const requestedHospitalId = selectedCase?.requestedSurgeryDate?.newHospital?.id || selectedCase?.requestedSurgeryDateNewHospital;

  const getHospitalName = useCallback((id) => {
    if (!id) {
      return '';
    }

    const name = hospitals?.find((item) => item.id === id)?.name;
    return name || '';
  }, [hospitals]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Approve New Surgery Date"
      subtitle={selectedCase?.formattedId || selectedCase?.id}
      size="md"
      autoSize
    >
      <div className="approve_surgery_date_modal" style={{ minWidth: 350 }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <div className="p-lg width-100">
            <div className="secondary">Current Surgery Date</div>

            {selectedCase?.date ? (
              <DatePicker
                desktopModeMediaQuery="(min-width: 0px)"
                format="DD/MM/YYYY"
                value={moment(selectedCase.date)}
                disabled
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: 'standard',
                  },
                }}
              />
            ) : (
              <TextField
                variant="standard"
                fullWidth
                disabled
                value="TBC"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <EventIcon style={{ fill: "#787e84", marginRight: '-12px' }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </div>

          <div className="p-lg width-100">
            <div className="secondary">Requested New Surgery Date</div>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={moment(requestedDate)}
              disabled
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                },
              }}
            />
          </div>

          {!!requestedHospitalId &&
            requestedHospitalId !==
            selectedCase?.hospitalUniq?.id && (
              <>
                <div className="p-lg width-100">
                  <div className="secondary">Current Hospital</div>
                  <TextField
                    variant="standard"
                    fullWidth
                    disabled
                    value={selectedCase?.hospital}
                  />
                </div>

                <div className="p-lg width-100">
                  <div className="secondary">Requested New Hospital</div>
                  <TextField
                    variant="standard"
                    fullWidth
                    disabled
                    value={getHospitalName(requestedHospitalId)}
                  />
                </div>
              </>
            )}
        </LocalizationProvider>

        {/* Desktop buttons */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <div className="p-lg width-100 d-flex space-between">
            <div className="m-r-md">
              <Button
                text="Reject"
                type="secondary"
                onClick={onReject}
                disabled={loading}
                loading={loading}
              />
            </div>
            <div className="m-l-md">
              <Button
                text="Approve"
                color="primary"
                onClick={onApprove}
                disabled={loading}
                loading={loading}
              />
            </div>
          </div>
        </Box>

        {/* Mobile buttons */}
        <Box sx={{ display: { md: 'none' } }}>
          <div className="p-md width-100 d-flex direction-column align-center">
            <div className="m-b-lg">
              <Button
                text="Approve"
                color="primary"
                onClick={onApprove}
                disabled={loading}
                loading={loading}
              />
            </div>
            <div>
              <Button
                text="Reject"
                type="secondary"
                onClick={onReject}
                disabled={loading}
                loading={loading}
              />
            </div>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default CaseApproveDateModal;
              
